<script>
    import { fade } from "svelte/transition";
    import { calculatorStore } from "../store/calculators.js";
    import { factoryStore } from "../store/factories.js";
    import { langTextStore } from "../store/langtexts.js";

    export let isFactory;
    export let currentSubSectionNameKey;

    $: $calculatorStore && setInitialState();
    $: ensureSubSection = setSubSection(
        isFactory,
        $calculatorStore.subSections
    );
    $: subSections = $calculatorStore.subSections.filter((ms) => {
        return ms.isFactorySection == isFactory && !ms.isSummarySection;
    });

    function setSubSection(isFactory, subSections) {
        currentSubSectionNameKey = subSections.subSectionNameKey;
    }
    function setInitialState() {
        if (
            $calculatorStore &&
            $calculatorStore.subSections &&
            $calculatorStore.subSections.length > 0
        ) {
            currentSubSectionNameKey =
                $calculatorStore.subSections[0].subSectionNameKey;
        }
    }

    function isSectionComplete(section) {
        if (section == undefined || section == null) return false;
        var subSection = $factoryStore.currentCalculator.subSections.find(
            (ss) => ss.subSectionNameKey == section.subSectionNameKey
        );
        if (subSection != null && subSection != undefined) {
            return subSection.markAsComplete;
        }
        return false;
    }
</script>

<div class="blur">
    <ol class="steps pt-0 mt-0 text-small"  style="text-transform:lowercase">
        <li
            class="motready"
            in:fade={{ duration: 800 }}
            class:selected={currentSubSectionNameKey == "basic-settings"}
            on:click={() => {
                currentSubSectionNameKey = "basic-settings";
            }}
        >
            {$langTextStore.getText("factory-settings-basic-settings")}
        </li>
        {#if $factoryStore.currentCalculator.subSections}
            {#each subSections as subSection}
                <!-- please note we send in the factory store to guarantee reactivity -->

                <li
                    class:ready={isSectionComplete(subSection, $factoryStore)}
                    in:fade={{ duration: 800 }}
                    class:selected={currentSubSectionNameKey ==
                        subSection.subSectionNameKey}
                    on:click={() => {
                        currentSubSectionNameKey = subSection.subSectionNameKey;
                    }}
                >
                    {$langTextStore.getText(subSection.subSectionNameKey)}
                </li>
            {/each}
        {/if}
    </ol>
</div>
